import { render, staticRenderFns } from "./manageSys.vue?vue&type=template&id=52ffa754&scoped=true&"
import script from "./manageSys.vue?vue&type=script&lang=js&"
export * from "./manageSys.vue?vue&type=script&lang=js&"
import style0 from "./manageSys.vue?vue&type=style&index=0&id=52ffa754&prod&lang=css&"
import style1 from "./manageSys.vue?vue&type=style&index=1&id=52ffa754&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ffa754",
  null
  
)

export default component.exports